import { Injectable, Type } from '@angular/core';

import { LazyServiceProviderBase } from './lazy-service-provider-base';

/**
 * Options for AccountMenuService Toggle method
 *
 * @stable
 */
export interface ToggleMenuOptions {
    /**
     * Adds optional initial virtual route
     */
    route?: string;
    /**
     * Sets menu to be opened in single page mode
     */
    singlePageMode?: boolean;
    /**
     * Sets menu anchor element
     */
    anchorElementKey?: string;
    /**
     * Indicates if the account menu is closed by the close button
     */
    closedWithButton?: boolean;
}

/**
 * @whatItDoes Provides functionality to manipulate the account menu
 *
 * @description
 *
 * # Overview
 *
 * This service provides functionality for manipulating the bottom sheet menu:
 *  - Toggle the menu
 *  - Set counter for menu item
 *
 * @stable
 */
@Injectable({
    providedIn: 'root',
})
export class AccountMenuService extends LazyServiceProviderBase {
    get version(): number {
        return this.inner.version;
    }

    get routerMode(): number {
        return this.inner.routerMode;
    }

    toggle(show: boolean, toggleOptions?: ToggleMenuOptions) {
        this.inner.toggle(show, toggleOptions);
    }

    getAccountMenuComponent(itemType: string | undefined): Type<any> | null {
        return this.inner.getAccountMenuComponent(itemType);
    }

    setItemCounter(itemName: string, count: any, cssClass?: string) {
        this.inner.setItemCounter(itemName, count, cssClass);
    }

    setActiveItem(itemName: string) {
        this.inner.setActiveItem(itemName);
    }

    updatePokerCashback() {
        this.inner.updatePokerCashback();
    }

    updateLoyaltyCashback() {
        this.inner.updateLoyaltyCashback();
    }

    updateCoralCashback() {
        this.inner.updateCoralCashback();
    }

    updateMLifeProfile() {
        this.inner.updateMLifeProfile();
    }

    setAccountMenuComponent(itemType: string, component: Type<any>) {
        this.inner.setAccountMenuComponent(itemType, component);
    }

    setReturnUrlCookie(url: string) {
        this.inner.setReturnUrlCookie(url);
    }

    removeReturnUrlCookie() {
        this.inner.removeReturnUrlCookie();
    }
}
